import Overview from "./S01Overview";
import Property from "./S02Property";
import CityStatus from "./S03City";
import Concept from "./S04Concept";
import Revenue from "./S05Revenue";
import Market from "./market/S05Market";
import Budget from "./S06Budget";
import CapRate from "./S07CapRate";
import Valuation from "./S08Valuation";
import Capital from "./S09Capital";
import Exit from "./S10Exit";
import JV from "./S11JV";
import Risks from "./S12Risks";
import NextSteps from "./S13Next";

export const SECTION_COMPONENTS = {
  overview: Overview, property: Property, city: CityStatus, concept: Concept, market: Market, revenue: Revenue,
  budget: Budget, caprate: CapRate, valuation: Valuation, capital: Capital, exit: Exit,
  jv: JV, risks: Risks, next: NextSteps,
};
